import { render, staticRenderFns } from "./gl_countdown.vue?vue&type=template&id=c67d2bc8&"
import script from "./gl_countdown.vue?vue&type=script&lang=js&"
export * from "./gl_countdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports